// Theme: platinum-mist
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'platinum-mist',
  name: 'PLATINUM MIST',
  tagline: 'PLATINUM MIST',
  description: 'Armadura de platina. Aço prateado e névoa de batalha, com gemas de azul elétrico.',
  category: 'premium-status',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#07090E', '#0D1520', '#B8CED8', '#5BC8FA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.38)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--accent) 58%, transparent)'
    },
    shellClasses: 'font-sans theme-platinum-mist'
  },
  colorVars: {
    '--accent': '#5BC8FA',
    '--accent-foreground': '#07090E',
    '--background': '#07090E',
    '--border': 'rgba(180, 200, 218, 0.20)',
    '--card': '#0D1520',
    '--card-border-active': 'rgba(91, 200, 250, 0.55)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E2EAF2',
    '--card-glow': 'rgba(180, 200, 218, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#07090E',
    '--foreground': '#D4DDE8',
    '--hold-fill': '#5BC8FA',
    '--input': 'rgba(180, 200, 218, 0.16)',
    '--modal-bg': '#07090E',
    '--modal-border': 'rgba(180, 200, 218, 0.20)',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.38)',
    '--muted': '#111B26',
    '--muted-foreground': 'rgba(180, 200, 218, 0.62)',
    '--nav-active': '#5BC8FA',
    '--nav-bg': 'rgba(7, 9, 14, 0.82)',
    '--popover': '#0D1520',
    '--popover-foreground': '#D4DDE8',
    '--primary': '#B8CED8',
    '--primary-foreground': '#07090E',
    '--ring': '#B8CED8',
    '--secondary': '#111B26',
    '--secondary-foreground': '#D4DDE8',
    '--streak': '#5BC8FA',
    '--success': '#22c55e',
    '--success-foreground': '#07090E',
    '--xp': '#5BC8FA',
    '--xp-bg': 'rgba(91, 200, 250, 0.10)'
  },
  resolvedVars: {
    '--accent': '#5BC8FA',
    '--accent-foreground': '#07090E',
    '--accent-foreground-hsl': '223 33% 4%',
    '--accent-foreground-oklch': 'from #07090E l c h',
    '--accent-hsl': '199 94% 67%',
    '--accent-oklch': 'from #5BC8FA l c h',
    '--background': '#07090E',
    '--background-hsl': '223 33% 4%',
    '--background-oklch': 'from #07090E l c h',
    '--border': 'rgba(180, 200, 218, 0.20)',
    '--border-w': '1px',
    '--card': '#0D1520',
    '--card-border-active': 'rgba(91, 200, 250, 0.55)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E2EAF2',
    '--card-foreground-hsl': '210 38% 92%',
    '--card-foreground-oklch': 'from #E2EAF2 l c h',
    '--card-glow': 'rgba(180, 200, 218, 0.10)',
    '--card-hsl': '215 42% 9%',
    '--card-oklch': 'from #0D1520 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#07090E',
    '--destructive-foreground-hsl': '223 33% 4%',
    '--destructive-foreground-oklch': 'from #07090E l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D4DDE8',
    '--foreground-hsl': '213 30% 87%',
    '--foreground-oklch': 'from #D4DDE8 l c h',
    '--hold-fill': '#5BC8FA',
    '--hold-fill-hsl': '199 94% 67%',
    '--hold-fill-oklch': 'from #5BC8FA l c h',
    '--input': 'rgba(180, 200, 218, 0.16)',
    '--modal-bg': '#07090E',
    '--modal-bg-hsl': '223 33% 4%',
    '--modal-bg-oklch': 'from #07090E l c h',
    '--modal-border': 'rgba(180, 200, 218, 0.20)',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.38)',
    '--muted': '#111B26',
    '--muted-foreground': 'rgba(180, 200, 218, 0.62)',
    '--muted-hsl': '211 38% 11%',
    '--muted-oklch': 'from #111B26 l c h',
    '--nav-active': '#5BC8FA',
    '--nav-active-hsl': '199 94% 67%',
    '--nav-active-oklch': 'from #5BC8FA l c h',
    '--nav-bg': 'rgba(7, 9, 14, 0.82)',
    '--popover': '#0D1520',
    '--popover-foreground': '#D4DDE8',
    '--popover-foreground-hsl': '213 30% 87%',
    '--popover-foreground-oklch': 'from #D4DDE8 l c h',
    '--popover-hsl': '215 42% 9%',
    '--popover-oklch': 'from #0D1520 l c h',
    '--primary': '#B8CED8',
    '--primary-foreground': '#07090E',
    '--primary-foreground-hsl': '223 33% 4%',
    '--primary-foreground-oklch': 'from #07090E l c h',
    '--primary-hsl': '199 29% 78%',
    '--primary-oklch': 'from #B8CED8 l c h',
    '--radius': '14px',
    '--ring': '#B8CED8',
    '--ring-hsl': '199 29% 78%',
    '--ring-oklch': 'from #B8CED8 l c h',
    '--secondary': '#111B26',
    '--secondary-foreground': '#D4DDE8',
    '--secondary-foreground-hsl': '213 30% 87%',
    '--secondary-foreground-oklch': 'from #D4DDE8 l c h',
    '--secondary-hsl': '211 38% 11%',
    '--secondary-oklch': 'from #111B26 l c h',
    '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.38)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--accent) 58%, transparent)',
    '--streak': '#5BC8FA',
    '--streak-hsl': '199 94% 67%',
    '--streak-oklch': 'from #5BC8FA l c h',
    '--success': '#22c55e',
    '--success-foreground': '#07090E',
    '--success-foreground-hsl': '223 33% 4%',
    '--success-foreground-oklch': 'from #07090E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(199 29% 78% / 0.15)',
    '--xp': '#5BC8FA',
    '--xp-bg': 'rgba(91, 200, 250, 0.10)',
    '--xp-hsl': '199 94% 67%',
    '--xp-oklch': 'from #5BC8FA l c h'
  }
}
